// extracted by mini-css-extract-plugin
export default {"text_num":"TitleNumInfo_text_num__HYT5j","title":"TitleNumInfo_title__+3F9m","num":"TitleNumInfo_num__i5sn6","tag":"TitleNumInfo_tag__mV44-"};